/**
 * @generated SignedSource<<1ee903b3a60d23de30ac2f2b8d2761f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountEditConnectEmployeeScreenLinkEmployeeMutation$variables = {
  employeeId: string;
  id: string;
  storeId?: string | null;
};
export type AccountEditConnectEmployeeScreenLinkEmployeeMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly linkEmployee: {
        readonly employee: {
          readonly id: string;
        } | null;
        readonly id: string;
      };
    } | null;
  };
};
export type AccountEditConnectEmployeeScreenLinkEmployeeMutation = {
  response: AccountEditConnectEmployeeScreenLinkEmployeeMutation$data;
  variables: AccountEditConnectEmployeeScreenLinkEmployeeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "employeeId",
                "variableName": "employeeId"
              }
            ],
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "linkEmployee",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditConnectEmployeeScreenLinkEmployeeMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AccountEditConnectEmployeeScreenLinkEmployeeMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "1625ae31bff08ba0605ec1ce27e28caf",
    "id": null,
    "metadata": {},
    "name": "AccountEditConnectEmployeeScreenLinkEmployeeMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditConnectEmployeeScreenLinkEmployeeMutation(\n  $id: ID!\n  $employeeId: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      linkEmployee(employeeId: $employeeId) {\n        id\n        employee {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cc6b35fd397da34a74ad49eee5ec687";

export default node;
